// extracted by mini-css-extract-plugin
export var closeButton = "_pu-2";
export var closeButtonIcon = "_pu-3";
export var lightboxContent = "_pu-1";
export var lightboxOverlay = "_pu-0";